// Navigation helpers of the pack pages. No imports: the actions pull axios (ESM), which CRA's Jest can't load.

// Id of the virtual pack that holds the items without a (live) pack.
export const NO_PACK = 'none';

// The tabs of a pack page, in order: URL key, label, key in a pack's `counts`.
export const PACK_TABS = [
  { key: 'modeles', label: 'Modèles', countKey: 'templates' },
  { key: 'fonds', label: 'Fonds', countKey: 'backgrounds' },
  { key: 'decorations', label: 'Décorations', countKey: 'decorations' },
  { key: 'emojis', label: 'Emojis', countKey: 'overlays' },
];

export const tabFromQuery = (query) => (PACK_TABS.some((tab) => tab.key === query?.tab) ? query.tab : PACK_TABS[0].key);

export const packPath = (packId, tab) => `/pack-${packId}${tab ? `?tab=${tab}` : ''}`;

// The pack preselected in a creation form opened from a pack page ('' = no pack).
export const defaultPackOf = (packId) => (packId === NO_PACK ? '' : packId);

// The packs list with « Sans pack » as its last row.
export const withNoPackRow = (packs, counts) => [...packs, { objectId: NO_PACK, name: 'Sans pack', virtual: true, counts }];
